/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TreatmentPlanSortBy {
    START_DATE = 'startDate',
    END_DATE = 'endDate',
    TREATMENT_TYPE = 'treatmentType',
}
